import { SRCImage } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { ResponsiveImage } from 'services/graphql';

interface CardBlockRecord extends CdaStructuredTextRecord {
  image: ResponsiveImage;
  title?: string;
  subtitle?: string;
}

export default function CardBlock({ title, subtitle, image }: CardBlockRecord) {
  return (
    <div>
      {title}
      {subtitle}
      {image && <SRCImage data={image.responsiveImage} />}
    </div>
  );
}
